/* eslint-disable import/first */
import React from 'react';

import css from './index.module.scss';

export default function MediaList({ widgetData }) {
  const { media: mediaList } = widgetData;

  return (
    <div className={css.root}>
      {mediaList?.map((media) => {
        if (media.action.type === 'webpage') {
          return '';
        }
        return (
          <div className={css.mediaTile} key={`media-${media.sequence}-${media.mediaUrl}`}>
            <div className={css.media}>
              <img src={`${media.mediaUrl}`} alt="" />
            </div>
            {media.title ? <div className={css.title}>{media.title}</div> : ''}
          </div>
        );
      })}
    </div>
  );
}
